"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configuration_1 = require("@common/configuration");
const app_service_1 = require("./app.service");
const _ = require("lodash");
class UnitsService extends app_service_1.AppService {
    constructor(token) {
        super(token);
        this.endpoint = configuration_1.Configuration.unitsServiceConfig().api;
        this.endpointV2 = configuration_1.Configuration.unitsServiceConfig().apiV2;
        this.endpointV3 = configuration_1.Configuration.unitsServiceConfig().apiV3;
    }
    async getUnits() {
        const result = await this.httpService.get(`${this.endpoint}/units/`, {
            headers: this.getHeaders(),
        });
        return result.data.data;
    }
    async getUuidByLegacyUnitId(unitId) {
        const response = await this.httpService.get(`${this.endpoint}/units?filter[legacy_unit_id]=${unitId}`, { headers: this.getHeaders() });
        return response.data.data.length > 0 ? _.get(response.data.data[0], "id", null) : null;
    }
    async getUnitByUnitId(uuid) {
        const response = await this.httpService.get(`${this.endpointV2}/units/${uuid}`, { headers: this.getHeaders() });
        return response.data.data;
    }
    async getUuidByLegacyUnitIdV2(unitId) {
        const response = await this.httpService.get(`${this.endpointV2}/units?filter[legacy_unit_id][in]=${unitId}`, { headers: this.getHeaders() });
        return response.data.data.length > 0 ? _.get(response.data.data[0], "id", null) : null;
    }
    async getUnitByUnitIdWithIncludes(uuid, includes) {
        const response = await this.httpService.get(`${this.endpointV2}/units/${uuid}?include=${includes}`, { headers: this.getHeaders() });
        return response.data;
    }
    async getUnitByUnitIdV2(uuid) {
        const response = await this.httpService.get(`${this.endpointV2}/units/${uuid}`, { headers: this.getHeaders() });
        return response.data.data;
    }
    async getHistoryChangesByUnitId(uuid, table_name, fields) {
        const response = await this.httpService.get(`${this.endpointV2}/history-changes?filter[table_name]=${table_name}&filter[fields]=${fields}&filter[record_id]=${uuid}`, { headers: this.getHeaders() });
        return response.data.data;
    }
    async patchUnit(uuid, data) {
        const response = await this.httpService.patch(`${this.endpointV2}/units/${uuid}`, data, { headers: this.getHeaders() });
        return response.data.data;
    }
    async getUnitBookingComplianceByUnitId(unitId) {
        const response = await this.httpService.get(`${this.endpointV2}/unit-booking-compliance/${unitId}`, { headers: this.getHeaders() });
        return response.data.data;
    }
    async getRoomsByUnit(uuid) {
        const response = await this.httpService.get(`${this.endpoint}/units/${uuid}?include=rooms`, { headers: this.getHeaders() });
        return response.data.included;
    }
    async getAllRoomTypes() {
        const response = await this.httpService.get(`${this.endpointV2}/room-types`, { headers: this.getHeaders() });
        return response.data.data;
    }
    async getAllBedTypes() {
        const response = await this.httpService.get(`${this.endpointV2}/bed-types`, { headers: this.getHeaders() });
        return response.data.data;
    }
    async getAllBedSizes() {
        const response = await this.httpService.get(`${this.endpointV2}/bed-sizes`, { headers: this.getHeaders() });
        return response.data.data;
    }
    async getRules() {
        const result = await this.httpService.get(`${this.endpointV3}/rules`, {
            headers: this.getHeaders(),
        });
        return result.data.data;
    }
    async getRuleValue(valueId) {
        const result = await this.httpService.get(`${this.endpointV3}/rule-values/${valueId}`, {
            headers: this.getHeaders(),
        });
        return result.data.data;
    }
    async getUnitRuleValuesByValueCode(valueCode) {
        const result = await this.httpService.get(`${this.endpointV3}/unit-rule-values?filter[value_code]=${valueCode}&filter[is_active]=true`, {
            headers: this.getHeaders(),
        });
        return result.data.data;
    }
    async getUnitRuleValuesByRuleAndValueCode(ruleCode, valueCode) {
        const response = await this.httpService.get(`${this.endpointV3}/unit-rule-values?filter[code]=${ruleCode}&filter[value_code]=${valueCode}&filter[is_active]=true&page[size]=100&page[number]=1`, {
            headers: this.getHeaders(),
        });
        let result = response.data.data;
        const { page, pages } = response.data.meta.pagination;
        if (page < pages) {
            for (let i = page + 1; i <= pages; i++) {
                const unitsRuleValues = await this.httpService.get(`${this.endpointV3}/unit-rule-values?filter[code]=${ruleCode}&filter[value_code]=${valueCode}&filter[is_active]=true&page[size]=100&page[number]=${i}`, {
                    headers: this.getHeaders(),
                });
                result = [...result, ...unitsRuleValues.data.data];
            }
        }
        return result;
    }
    async getUnitRules(parameters) {
        //TODO: wrap this method withing a pagination handler
        //@ts-ignore
        const requestParameters = new URLSearchParams();
        for (const [key, value] of Object.entries(parameters)) {
            if (_.isNil(value))
                continue;
            const formatedValue = Array.isArray(value) ? value.join(',') : value;
            requestParameters.set(key, formatedValue);
            //TODO: add validation or parsing for other data types
        }
        const result = await this.httpService.get(`${this.endpointV3}/unit-rule-values?${requestParameters.toString()}`, {
            headers: this.getHeaders(),
        });
        return result.data.data;
    }
    async postRuleValue(data) {
        const response = await this.httpService.post(`${this.endpointV3}/rule-values`, data, { headers: this.getHeaders() });
        return response.data.data;
    }
    async patchRuleValue(ruleValueId, data) {
        const response = await this.httpService.patch(`${this.endpointV3}/rule-values/${ruleValueId}`, data, { headers: this.getHeaders() });
        return response.data.data;
    }
    async getRuleGroups() {
        const result = await this.httpService.get(`${this.endpointV3}/rules-group`, {
            headers: this.getHeaders(),
        });
        return result.data.data;
    }
    async createRoom(unitId, rooms) {
        if (rooms.length == 0) {
            return;
        }
        const data = {
            data: rooms.map((x) => {
                return {
                    type: "room",
                    attributes: {
                        unit_id: unitId,
                        room_type: { id: x.roomTypeId },
                        beds: x.beds.map((bed) => {
                            return {
                                bed_type: { id: bed.bedType },
                                bed_size: { id: bed.bedSize },
                            };
                        }),
                    },
                };
            }),
        };
        const response = await this.httpService.post(`${this.endpoint}/rooms`, data, { headers: this.getHeaders() });
        return response.data.data;
    }
    async updateRoom(uuid, roomId, roomType, beds) {
        const data = {
            data: {
                type: "room",
                attributes: {
                    unit_id: uuid,
                    room_type: { id: roomType },
                    beds: beds.map((bed) => {
                        return {
                            bed_type: { id: bed.bedType },
                            bed_size: { id: bed.bedSize },
                        };
                    }),
                },
            },
        };
        const response = await this.httpService.patch(`${this.endpoint}/rooms/${roomId}`, data, { headers: this.getHeaders() });
        return response.data.data;
    }
    async deleteRoom(roomId) {
        try {
            await this.httpService.delete(`${this.endpoint}/rooms/${roomId}`, { headers: this.getHeaders() });
        }
        catch (error) {
            console.error(error);
        }
    }
    async deleteRuleValue(valueId) {
        await this.httpService.delete(`${this.endpointV3}/rule-values/${valueId}`, { headers: this.getHeaders() });
    }
    async bulkRoom(unitUUid, body, userEmail) {
        try {
            const requestBody = { data: [] };
            body.forEach((x) => {
                requestBody.data.push({
                    type: "bulk_room",
                    id: !_.isNil(x.roomId) ? x.roomId : null,
                    attributes: {
                        unit_id: unitUUid,
                        room_type: { id: !_.isNil(x.roomTypeId) ? x.roomTypeId : null },
                        beds: !_.isNil(x.beds)
                            ? x.beds.map((bed) => {
                                return {
                                    bed_type: { id: bed.bedType },
                                    bed_size: { id: bed.bedSize },
                                };
                            })
                            : [],
                        action: x.action,
                        done_by: userEmail,
                    },
                });
            });
            await this.httpService.post(`${this.endpointV2}/rooms/bulk`, requestBody, { headers: this.getHeaders() });
        }
        catch (error) {
            console.error(error);
        }
    }
    async updateMinBookingAge(unitId, minBookingAge) {
        const data = {
            data: {
                type: "unit",
                attributes: {
                    min_booking_age: minBookingAge,
                },
            },
        };
        const response = await this.httpService.patch(`${this.endpointV2}/units/${unitId}`, data, { headers: this.getHeaders() });
        return response.data.data;
    }
    async updateComplianceNotes(unitId, notes) {
        const data = {
            data: {
                type: "unit_booking_compliance",
                attributes: {
                    unit_id: unitId,
                    compliance_notes: notes,
                },
            },
        };
        const response = await this.httpService.patch(`${this.endpointV2}/unit-booking-compliance/${unitId}`, data, { headers: this.getHeaders() });
        return response.data.data;
    }
    async searchUnits(formData) {
        const data = this.translateFormToFilters(formData);
        const response = await this.httpService.get(`${this.endpoint}/units`, {
            data: { data },
            headers: this.getHeaders(),
            params: {
                "page[size]": 500,
                ...data,
            },
        });
        return response.data.data;
    }
    translateFormToFilters(formData) {
        const fieldToFilterMappings = {
            unitIDOrCode: (value) => {
                if (!value || !Number.isInteger(parseInt(value.charAt(0)))) {
                    return "filter[unit_code][istartswith]";
                }
                else {
                    //it's a unit ID!
                    return "filter[legacy_unit_id]";
                }
            },
            propertyName: () => "filter[name][icontains]",
            streetAddress: () => "filter[address_1][icontains]",
            city: () => "filter[city][icontains]",
            zipCode: () => "filter[zip][iexact]",
            ids: () => "filter[id][in]",
        };
        const translatedFields = {};
        Object.keys(formData).forEach((fieldName) => {
            const fieldValue = formData[fieldName];
            const newKey = fieldToFilterMappings[fieldName](fieldValue);
            translatedFields[newKey] = fieldValue;
        });
        // translatedFields["filter[page][size]"] = 500;
        return translatedFields;
    }
    async getGwUnitStaffers(unitId) {
        const result = await this.httpService.get(`${this.endpoint}/gw_unit_staffers?filter[unit]=${unitId}&staffer_type=cx_contact`, {
            headers: this.getHeaders(),
        });
        return result.data;
    }
}
exports.UnitsService = UnitsService;
//# sourceMappingURL=units.service.js.map